import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import MachineCard, { MachineCardPlaceholder } from "@/components/machine-card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { Separator } from "@/components/ui/separator";
import { OrdersTable } from "@/components/orders-table";
import { requireShopAuth } from "@/lib/shop-auth-guard";
import { getCustomerMachinesOptions } from "@/client/@tanstack/react-query.gen";
import { retryFunc } from "@/api/retry";
import { useAuth } from "@/hooks/auth";
import { useCustomerId } from "@/components/customer-id-provider";
import { useTranslation } from "react-i18next";
import { LoadingComponent } from "@/components/loading";

export const Route = createFileRoute("/")({
  beforeLoad: requireShopAuth,
  component: () => <HomeComponent />,
});

function HomeComponent() {
  const { customerId } = useCustomerId();
  const { isLoading } = useAuth();
  const { t } = useTranslation();

  const { data: machinesData, isLoading: machinesLoading } = useQuery({
    ...getCustomerMachinesOptions({
    path: {
      customer_id: customerId!,
    }, 
    }),
    retry: retryFunc,
    enabled: !!customerId,
  });

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <div className="py-4">
      {customerId && (
        <>
          <section>
            <h2 className="text-2xl font-bold mb-4">{t("index.myMachines")}</h2>
            <Carousel>
              <CarouselContent>
                {!machinesLoading &&
                  machinesData?.map((x) => (
                    <CarouselItem
                      className="sm:basis-[80%] md:basis-[60%] lg:basis-[30%] basis-full"
                      key={x.id}
                    >
                      <Link
                        to="/customers/$customerId/machines/$machineId"
                        params={{
                          // TODO
                          customerId: customerId!,
                          machineId: x.id,
                        }}
                      >
                        <MachineCard machine={x}></MachineCard>
                      </Link>
                    </CarouselItem>
                  ))}
                {machinesLoading && (
                  <>
                    <CarouselItem className="sm:basis-[80%] md:basis-[60%] lg:basis-[30%] basis-full">
                      <MachineCardPlaceholder></MachineCardPlaceholder>
                    </CarouselItem>
                    <CarouselItem className="sm:basis-[80%] md:basis-[60%] lg:basis-[30%] basis-full">
                      <MachineCardPlaceholder></MachineCardPlaceholder>
                    </CarouselItem>
                    <CarouselItem className="sm:basis-[80%] md:basis-[60%] lg:basis-[30%] basis-full">
                      <MachineCardPlaceholder></MachineCardPlaceholder>
                    </CarouselItem>
                    <CarouselItem className="sm:basis-[80%] md:basis-[60%] lg:basis-[30%] basis-full">
                      <MachineCardPlaceholder></MachineCardPlaceholder>
                    </CarouselItem>
                  </>
                )}
              </CarouselContent>
            </Carousel>
          </section>
          <Separator className="my-8"></Separator>
          {customerId && (
            <section>
              <h2 className="text-2xl font-bold mb-4">
                {t("index.latestRequests")}
              </h2>
              <OrdersTable customerId={customerId!}></OrdersTable>
            </section>
          )}
        </>
      )}
      {!customerId && (
        <section>
          <h2 className="text-2xl font-bold mb-4">
            {t("index.noCustomerSelected")}
          </h2>
        </section>
      )}
    </div>
  );
}
